"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let id = 0;
function jsonp(options) {
    if (!options || !options.url) {
        return;
    }
    const scriptNode = document.createElement('script');
    const data = options.data || {};
    let url = options.url;
    const callback = options.callback;
    const fnName = '__jsonp_cb' + id++;
    // 添加回调函数
    data.callback = fnName;
    // 拼接url
    const params = [];
    // tslint:disable-next-line:forin
    for (const key in data) {
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
    }
    url += url.indexOf('?') > 0 ? '&' : '?';
    url += params.join('&');
    scriptNode.src = url;
    // 传递的是一个匿名的回调函数，要执行的话，暴露为一个全局方法
    window[fnName] = (ret) => {
        callback && callback(ret);
        document.head.removeChild(scriptNode);
        delete window[fnName];
    };
    // 出错处理
    scriptNode.onerror = () => {
        callback && callback({ error: 'error' });
        document.head.removeChild(scriptNode);
        global[fnName] && delete global[fnName];
    };
    scriptNode.type = 'text/javascript';
    document.head.appendChild(scriptNode);
}
exports.default = jsonp;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoianNvbnAuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJqc29ucC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLElBQUksRUFBRSxHQUFHLENBQUMsQ0FBQztBQUVYLFNBQXdCLEtBQUssQ0FBQyxPQUF5RDtJQUNwRixJQUFJLENBQUMsT0FBTyxJQUFJLENBQUMsT0FBTyxDQUFDLEdBQUcsRUFBRTtRQUFFLE9BQU87S0FBRTtJQUV6QyxNQUFNLFVBQVUsR0FBRyxRQUFRLENBQUMsYUFBYSxDQUFDLFFBQVEsQ0FBQyxDQUFDO0lBQ3BELE1BQU0sSUFBSSxHQUFHLE9BQU8sQ0FBQyxJQUFJLElBQUksRUFBRSxDQUFDO0lBQ2hDLElBQUksR0FBRyxHQUFHLE9BQU8sQ0FBQyxHQUFHLENBQUM7SUFDdEIsTUFBTSxRQUFRLEdBQUcsT0FBTyxDQUFDLFFBQVEsQ0FBQztJQUNsQyxNQUFNLE1BQU0sR0FBRyxZQUFZLEdBQUcsRUFBRSxFQUFFLENBQUM7SUFFbkMsU0FBUztJQUNULElBQUksQ0FBQyxRQUFRLEdBQUcsTUFBTSxDQUFDO0lBRXZCLFFBQVE7SUFDUixNQUFNLE1BQU0sR0FBYSxFQUFFLENBQUM7SUFDNUIsaUNBQWlDO0lBQ2pDLEtBQUssTUFBTSxHQUFHLElBQUksSUFBSSxFQUFFO1FBQ3JCLE1BQU0sQ0FBQyxJQUFJLENBQUMsa0JBQWtCLENBQUMsR0FBRyxDQUFDLEdBQUcsR0FBRyxHQUFHLGtCQUFrQixDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUM7S0FDN0U7SUFDRCxHQUFHLElBQUksR0FBRyxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDO0lBQ3hDLEdBQUcsSUFBSSxNQUFNLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO0lBQ3hCLFVBQVUsQ0FBQyxHQUFHLEdBQUcsR0FBRyxDQUFDO0lBRXJCLGdDQUFnQztJQUNoQyxNQUFNLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxHQUFHLEVBQUUsRUFBRTtRQUN0QixRQUFRLElBQUksUUFBUSxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQzFCLFFBQVEsQ0FBQyxJQUFLLENBQUMsV0FBVyxDQUFDLFVBQVUsQ0FBQyxDQUFDO1FBQ3ZDLE9BQU8sTUFBTSxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQ3pCLENBQUMsQ0FBQztJQUVGLE9BQU87SUFDUCxVQUFVLENBQUMsT0FBTyxHQUFHLEdBQUcsRUFBRTtRQUN2QixRQUFRLElBQUksUUFBUSxDQUFDLEVBQUUsS0FBSyxFQUFFLE9BQU8sRUFBRSxDQUFDLENBQUM7UUFDekMsUUFBUSxDQUFDLElBQUksQ0FBQyxXQUFXLENBQUMsVUFBVSxDQUFDLENBQUM7UUFDdEMsTUFBTSxDQUFDLE1BQU0sQ0FBQyxJQUFJLE9BQU8sTUFBTSxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQzNDLENBQUMsQ0FBQztJQUVGLFVBQVUsQ0FBQyxJQUFJLEdBQUcsaUJBQWlCLENBQUM7SUFDcEMsUUFBUSxDQUFDLElBQUssQ0FBQyxXQUFXLENBQUMsVUFBVSxDQUFDLENBQUM7QUFDMUMsQ0FBQztBQXRDRCx3QkFzQ0MifQ==